import { useEffect, useState } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { toast } from 'react-toastify'
import '../../../assets/css/notification.css'
import { isNullOrEmpty } from '../../../config/ENV'
import { JobService } from '../../../services/JobService'
import Linkify from 'react-linkify'
import { Link, NavLink } from 'react-router-dom'
import { showLocalDateTime } from '../../../utilities/timeutility'
const Notifications = (props) => {
  const [notificationList, setNotificationsList] = useState([])
  let count = 0
  useEffect(() => {
    getNotification()
  }, [count])

  const getNotification = () => {
    JobService.getNotificationService().then((response) => {
      if (response.status === 200) {
        if (!isNullOrEmpty(response.data.notifications)) {
          setNotificationsList(response.data.notifications)
        }
      }
    })
  }

  const UpdateNotification = (id) => {
    JobService.updateNotification(id).then((response) => {
      try {
        let notification = response.data

        if (notification !== null) {
          getNotification()
        }
      } catch (error) {
        console.log('readNotification' + JSON.stringify(error))
      }
    })
  }

  const readNotification = (notification) => {
    window.localStorage.setItem('requestId', notification.contextId)
    UpdateNotification(notification.id)

    setTimeout(() => {
      window.location.reload()
    }, 100)
  }

  const deletenotification = (id) => {
    JobService.deleteNotification(id).then((response) => {
      try {
        let notification = response.data

        if (notification !== null) {
          getNotification()
        }
      } catch (error) {
        console.log('readNotification' + JSON.stringify(error))
      }
    })
  }

  const removenotification = (notification) => {
    deletenotification(notification.id)
    setTimeout(() => {
      window.location.reload()
    })
  }

  return (
    <>
      {' '}
      <div
        className="bodyContent 
        grid max-md:gap-7 min-md:gap-8 min-xl:gap-12 
        max-lg:grid-cols-1 min-lg:grid-cols-5 min-2xl:grid-cols-3 min-md:absolute 
        min-md:ml-48 min-xl:ml-52 min-md:top-24 -z-10 
        min-md:min-w-[70%] min-lg:min-w-[80%]  min-md:pr-[3%]"
      >
        <div
          className="notificationsContainer 
        order-1 
        max-lg:col-span-1 min-lg:col-span-3 min-xl:col-span-3 min-2xl:col-span-2 "
        >
          <div className="notificationsWrapper flex flex-col gap-9 max-md:mx-4 min-lg:w-full">
            <div className="notifications max-lg:pb-12">
              <div className="notificationsTitle text-2xl font-bold text-primary-dark pb-3 max-md:pt-5">
                Notifications
              </div>
              <div
                className="notificationsWrapper max-lg:pb-5 overflow-y-scroll 
                scrollbar-none hover:scrollbar-thin scrollbar-thumb-rounded-md scrollbar-thumb-Blue-600 scrollbar-track-Gray-200"
              >
                <div className="t-grid grid-cols-1 gap-4 min-md:p-1 pr-2">
                  {notificationList.length > 0 &&
                    notificationList.map((notification, index) => (
                      <div key={index}>
                        {notification.status.value == 'Read' ? (
                          <>
                            <div
                              className="notification relative bg-primary-white t-rounded-xl overflow-hidden
                                shadow-md transition-all t-ease-in-out t-duration-200"
                            >
                              <div
                                className=" pl-4 pr-10 t-py-5 
                                border-l-[6px] border-l-gray-500  "
                              >
                                <Row>
                                  <Col>
                                    <Col className="col-11">
                                      <strong>{notification.senderName}</strong>
                                    </Col>
                                  </Col>
                                </Row>
                                <Row className="center">
                                  <Col className="col-11">
                                    <Link
                                      className="text-dark"
                                      to={{
                                        pathname:
                                          notification.type.key ==
                                          'JOBREQ_NOTES'
                                            ? `/addrequest/${notification.contextId}?t=notes`
                                            : `/viewcandidatedetails/${notification.contextId2}/${notification.contextId}`,
                                        state: {
                                          componentName: 'notifications',
                                        },
                                      }}
                                      onClick={() =>
                                        readNotification(notification)
                                      }
                                    >
                                      <span
                                        className=" border-l-gray-500
                                    flex flex-row min-lg:items-center justify-between"
                                        key={notification.id}
                                      >
                                        <Col className="col-9">
                                          {' '}
                                          <Linkify className="text-sm pr-7 basis-[90%] t-basis-notify pl-2 max-lg:pl-3">
                                            {notification.description}
                                          </Linkify>
                                        </Col>
                                        <Col className="col-3">
                                          <div className="font-semibold t-font-size-notification   t-justify-content-end  pb-1 basis-[10%] t-basis-date justify-end">
                                            {showLocalDateTime(
                                              notification.createdOn,
                                            )}
                                          </div>
                                        </Col>
                                      </span>
                                    </Link>{' '}
                                  </Col>

                                  <Col className="col-1">
                                    {' '}
                                    <Button
                                      onClick={() =>
                                        removenotification(notification)
                                      }
                                    >
                                      Delete
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div
                              className="notification relative bg-blue-50 t-rounded-xl overflow-hidden
                                shadow-md transition-all t-ease-in-out t-duration-200"
                            >
                              <div
                                className=" pl-4 pr-10 t-py-5 
                                border-l-[6px] border-l-primary-blue  "
                              >
                                <div className="notification_Dot max-lg:mt-1 w-2 h-2 bg-primary-blue rounded-full pr-1"></div>

                                <Row>
                                  <Col>
                                    <Col className="col-11">
                                      <strong>{notification.senderName}</strong>
                                    </Col>
                                  </Col>
                                </Row>
                                <Row className="center">
                                  <Col className="col-11">
                                    <Link
                                      onClick={() =>
                                        readNotification(notification)
                                      }
                                      className="text-dark"
                                      to={{
                                        pathname:
                                          notification.type.key ==
                                          'JOBREQ_NOTES'
                                            ? `/addrequest/${notification.contextId}?t=notes`
                                            : `/viewcandidatedetails/${notification.contextId2}/${notification.contextId}`,
                                        state: {
                                          componentName: 'notifications',
                                        },
                                      }}
                                    >
                                      <span
                                        className=" border-l-gray-500
                                    flex flex-row min-lg:items-center justify-between"
                                        key={notification.id}
                                      >
                                        <Col className="col-9">
                                          {' '}
                                          <Linkify className="text-sm pr-7 basis-[90%] t-basis-notify pl-2 max-lg:pl-3">
                                            {notification.description}
                                          </Linkify>
                                        </Col>
                                        <Col className="col-3">
                                          <div className="font-semibold  t-font-size-notification  t-justify-content-end  pb-1 basis-[10%] t-basis-date justify-end">
                                            {showLocalDateTime(
                                              notification.createdOn,
                                            )}
                                          </div>
                                        </Col>
                                      </span>
                                    </Link>
                                  </Col>

                                  <Col className="col-1">
                                    {' '}
                                    <Button
                                      onClick={() =>
                                        removenotification(notification)
                                      }
                                    >
                                      Delete
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Notifications
